import {useDebugValue, useEffect} from 'react';

import {useInitialization} from '../../../hooks';
import {getObjectValues} from '../../../utils';

function useDatesActions(data) {
    const {
        events: {
            onSettingsChange,
            onCurrentValuesChange,
            onLatestValuesChange
        },
        initialSettings,
        changeSettings,
        initialValues,
        currentValues,
        latestValues,
        setCurrentValues,
        setCurrentValuesDefault,
        setCurrentValuesInitial,
        setCurrentValuesLatest,
        setLatestValues,
        setLatestValuesDefault,
        setLatestValuesInitial,
        setLatestValuesCurrent,
        setAllValues,
        setAllValuesDefault,
        setAllValuesInitial
    } = data;

    const {
        isInitialized
    } = useInitialization();

    function setSettings(nextSettings) {
        changeSettings(nextSettings);

        onSettingsChange(nextSettings);
    }

    function setSettingsInitial() {
        setSettings(initialSettings);
    }

    function setIsOpen(isOpen) {
        setSettings({
            isOpen
        });
    }

    /* istanbul ignore next */
    function setReadOnly(readOnly) {
        setSettings({
            readOnly
        });
    }

    function setShowContinueButton(showContinueButton) {
        setSettings({
            showContinueButton
        });
    }

    useEffect(setSettingsInitial, [...getObjectValues(initialSettings)]);

    useEffect(setAllValuesInitial, [...getObjectValues(initialValues)]);

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(function triggerCurrentValuesChange() {
        if (isInitialized) {
            onCurrentValuesChange(currentValues);
        }
    }, [...getObjectValues(currentValues)]);
    /* eslint-enable react-hooks/exhaustive-deps */

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(function triggerLatestValuesChange() {
        if (isInitialized) {
            onLatestValuesChange(latestValues);
        }
    }, [...getObjectValues(latestValues)]);
    /* eslint-enable react-hooks/exhaustive-deps */

    const result = {
        setSettings,
        setSettingsInitial,
        setIsOpen,
        setReadOnly,
        setShowContinueButton,
        setCurrentValues,
        setCurrentValuesDefault,
        setCurrentValuesInitial,
        setCurrentValuesLatest,
        setLatestValues,
        setLatestValuesDefault,
        setLatestValuesInitial,
        setLatestValuesCurrent,
        setAllValues,
        setAllValuesDefault,
        setAllValuesInitial
    };

    useDebugValue(result);

    return result;
}

export {useDatesActions};
